import { defineMessage } from 'react-intl';
export const HISTORY_SUGGESTIONS_SHOWN = 5;
export const BROWSING_ONLINE_EVENTS_TEXT = defineMessage({
    id: 'Online',
    defaultMessage: 'Online',
});
export const ONLINE_EVENTS_LOCATION_SLUG = 'online';
export const SUGGESTION_TYPE_HISTORY = 'recent';
